import React, { useEffect, useState } from "react";
import Header from "../common/header/Header";
import FullWidthCard from "../common/social-media-card/full-width-card";
import calender from "../../assets/images/mcalendar.png";
import facebook from "../../assets/images/meta.svg";

import {
  disconnectMetaIntegration,
  fetchMetaAdsData,
  fetchMetaIntegrationExistData,
  fetchMicrosoftIntegrationExistData,
  metaLogin,
  postMetaAccountSelection,
} from "../../js/api/fb-integration";
import { CloseIcon } from "../../assets/icons/close-icon-simple";
import FormComponent from "./facebook/form-component";
import { getAccessToken, redirectUri } from "../common/constant/constant";
import { useLocation, useNavigate } from "react-router";
import MetaAdsSelector from "./facebook/meta-ads-selector";
import SecondaryButton from "../common/buttons/SecondaryButton";
import MetaDeleteModal from "./facebook/meta-delete-modal";
import { Toast } from "../common/toast/toast";
import btnConnectMicrosoftCalendar from "../../assets/images/btn-calendar-connect.png";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import HasRole from "../../guards/HasRole";
import { ROLES } from "../common/constant/roles";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const IntegrationDashboard = () => {
  const [errors, setErrors] = useState({});
  const [isFbIntegration, setIsFbIntegration] = useState({
    integrationExist: false,
  });
  const [isMicroSoftIntegration, setIsMicrosoftIntegration] = useState(false);
  const [isMicrosoftDisconnect, setIsMicrosoftDisconnect] = useState(false);
  const [isMicrosoft, setIsMicrosoft] = useState(false);
  const [isMetaLogin, setIsMetaLogin] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [accoutDetails, setAccountDetails] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedAdAccount, setSelectedAdAccount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [toasts, setToasts] = useState([]);
  const location = useLocation();
  const modifiedUrl = window.location.origin + "/integrations";
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    appId: "",
    appSecret: "",
    redirectUri: modifiedUrl,
  });

  const accessToken = getAccessToken(location);
  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000); // Auto-dismiss after 3 seconds
  };
  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };
  const MetaLogin = () => {
    if (!isMetaLogin) return;

    // Navigate to the login URL in the same window
    window.location.href = isMetaLogin;
  };

  useEffect(() => {
    MetaLogin();
  }, [isMetaLogin]);

  useEffect(() => {
    console.log("accessToken", accessToken);
    if (accessToken) {
      setIsLoading(true);
      fetchMetaAdsData(accessToken, setAccountDetails).then((res) => {
        setIsLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    console.log("modifiedUrl", modifiedUrl);
  }, [modifiedUrl]);

  useEffect(() => {
    fetchMetaIntegrationExistData(setIsFbIntegration);
    fetchMicrosoftIntegrationExistData(setIsMicrosoftIntegration);
  }, []);

  useEffect(() => {
    fetchMetaIntegrationExistData(setIsFbIntegration);
  }, [isLoading]);

  useEffect(() => {
    console.log("isMicroSoftIntegration", isMicroSoftIntegration);
  }, [isMicroSoftIntegration]);

  useEffect(() => {
    console.log("isFbIntegration", isFbIntegration);
    console.log(
      "isFbIntegration.integrationExist",
      isFbIntegration.integrationExist
    );
    console.log("isMetaLogin", isMetaLogin);
  }, [isFbIntegration, isMetaLogin]);

  const disconnectMeta = () => {
    setIsMicrosoftDisconnect(false);
    setIsDeleteOpen(true);
  };
  const disconnectMicrosoft = () => {
    setIsMicrosoftDisconnect(true);
    setIsDeleteOpen(true);
  };

  const handleSubmit = (e, errors, setErrors) => {
    e.preventDefault();
    let newErrors = {};
    if (!formData.appId) newErrors.appId = "App ID is required";
    if (!formData.appSecret) newErrors.appSecret = "App Secret is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    console.log("Form Submitted", formData);
    metaLogin(formData, setIsMetaLogin);
  };

  const onSubmitMetaAdsSelector = () => {
    setIsLoading(true);
    const data = accoutDetails;
    const metaAdCredentialID = data.metaAdCredentialID;
    console.log("metaAdCredentialID", metaAdCredentialID);
    console.log("selectedAccount", selectedAccount);
    console.log("selectedAdAccount", selectedAdAccount);
    postMetaAccountSelection(
      metaAdCredentialID,
      selectedAccount,
      selectedAdAccount
    )
      .then((response) => {
        navigate("/integrations");
        setAccountDetails(false);
        setIsFbIntegration({ isFbIntegration, integrationExist: true });
        console.log("response", response);
        setIsLoading(false);
        addToast(
          "Successfully connected to Facebook. Your integration is now active!",
          "success"
        );
      })
      .catch(() => {
        addToast("Unable to disconnect Facebook", "error");
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : `${name} is required`,
    }));
  };

  const connectMicrosoft = async (e) => {
    try {
      await axios
        .get(ENDPOINTS.CALENDAR.MICROSOFT_CALENDAR_CONNECT)
        .then((res) => {
          console.log(res.data.data);
          window.open(res.data.data, "_blank");
        });
    } catch (error) {}
  };

  return (
    <>
      <Header headertitle="Integrations" />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      {isLoading ? (
        <div class="spinnerwrapper">
          <div class="spinner"></div>
        </div>
      ) : (
        <div>
          <div className="px-9 pt-3 grid grid-cols-3 gap-[26px]">
            {/* <HasRole roles={[ROLES.ADMIN]}> */}
              <AllowedAccess
                roles={[ROLES.ADMIN]}
                permissions={[PermissionList.integration.facebook_integration]}
              >
                <FullWidthCard
                  imageSrc={facebook}
                  title="Meta"
                  description="Effortlessly connect with Facebook to streamline your scheduling and stay perfectly organized."
                  buttonText={
                    isFbIntegration.integrationExist ? "Disconnect" : "Connect"
                  }
                  isfbDisconnect={isFbIntegration.integrationExist}
                  buttonDisable={isFbIntegration.integrationExist}
                  classes="mt-6"
                  cardType="block"
                  fb={true}
                  connected={isFbIntegration.integrationExist}
                  isFbIntegration={isFbIntegration}
                  onClick={() => {
                    isFbIntegration.integrationExist
                      ? disconnectMeta()
                      : setIsOpen(!isOpen);
                    setIsMicrosoft(false);
                  }}
                />
              </AllowedAccess>
            {/* </HasRole> */}
            <AllowedAccess
              permissions={[
                PermissionList.integration.microsoft_calendar_integration,
              ]}
            >
              <FullWidthCard
                imageSrc={calender}
                title="Microsoft Calendar"
                description="Seamlessly integrate your calendar to simplify scheduling, manage your appointments efficiently, and stay effortlessly organized."
                buttonText={isMicroSoftIntegration ? "Disconnect" : "Connect"}
                classes="mt-6"
                cardType="block"
                isMicroSoftIntegration={isMicroSoftIntegration}
                connected={isMicroSoftIntegration}
                onClick={() => {
                  if (isMicroSoftIntegration) {
                    // microsoft disconnect function called here
                    disconnectMicrosoft();
                    console.log(
                      "isMicroSoftIntegration",
                      isMicroSoftIntegration
                    );
                  } else {
                    setIsOpen(!isOpen);
                    setIsMicrosoft(true);
                  }
                }}
              />
            </AllowedAccess>
          </div>

          {/* <div className='px-9 pt-3'>
                                        <FullWidthCard
                                                imageSrc={calender}
                                                title="Calendar"
                                                description="Seamlessly integrate your calendar to simplify scheduling, manage your appointments efficiently, and stay effortlessly organized."
                                                buttonText="Connect"
                                                classes="mt-6"
                                        />
                                        <FullWidthCard
                                                imageSrc={facebook}
                                                title="Facebook"
                                                description="Effortlessly connect with Facebook to streamline your scheduling, stay perfectly organized, and simplify event management effortlessly."
                                                buttonText="Connect"
                                                classes="mt-6"
                                        />
                                </div> */}
          <div
            className={`fixed top-[70px] right-1 flex flex-col h-screen  w-[570px] bg-white border-l border-[#C8D6E6] transform ${
              isOpen ? "translate-x-0" : "translate-x-full"
            } transition-transform duration-300`}
          >
            <div className="relative h-full">
              {isMicrosoft ? (
                <div className="text-center">
                  <div className="flex justify-between mt-9 pb-9 border-b">
                    <div className="ml-[35px] text-[20px] text-[#060427] font-[500]">
                      Calendar Integration
                    </div>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                      className="w-5 mr-[35px]"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                  <div className="flex justify-center mt-6">
                    <button
                      className="btnMicrosoftCalendar"
                      onClick={(e) => connectMicrosoft(e)}
                    >
                      <img src={btnConnectMicrosoftCalendar} alt="" />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex justify-between mt-9 pb-9 border-b">
                    <div className="ml-[35px] text-[20px] text-[#060427] font-[500]">
                      Meta Integration
                    </div>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                      className="w-5 mr-[35px]"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                  <FormComponent
                    formData={formData}
                    setFormData={setFormData}
                    handleSubmit={handleSubmit}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                  />
                  <div className="absolute shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-[70px] right-[-5px] w-[574px] bg-white  flex gap-5">
                    <button
                      onClick={(e) => handleSubmit(e, errors, setErrors)}
                      className=" btn-primary-base-bar primary_btn"
                    >
                      Submit
                    </button>
                    <SecondaryButton
                      label="Cancel"
                      onClick={() => {
                        setIsOpen(false);
                        setFormData({
                          appId: "",
                          appSecret: "",
                          redirectUri,
                        });
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <MetaDeleteModal
            setIsMicrosoftIntegration={setIsMicrosoftIntegration}
            isMicrosoftDisconnect={isMicrosoftDisconnect}
            addToast={addToast}
            isDeleteOpen={isDeleteOpen}
            isFbIntegration={isFbIntegration}
            setIsFbIntegration={setIsFbIntegration}
            setIsDeleteOpen={setIsDeleteOpen}
            imageSrc={isMicrosoftDisconnect ? calender : facebook}
            setIsLoading={setIsLoading}
          />

          {accoutDetails && (
            <MetaAdsSelector
              selectedAccount={selectedAccount}
              selectedAdAccount={selectedAdAccount}
              setSelectedAccount={setSelectedAccount}
              setSelectedAdAccount={setSelectedAdAccount}
              data={accoutDetails}
              setAccountDetails={setAccountDetails}
              setData={setAccountDetails}
              onSubmit={onSubmitMetaAdsSelector}
            />
          )}
        </div>
      )}
    </>
  );
};

export default IntegrationDashboard;
